module.exports = __webpack_public_path__ + "img/vu-spinlab-logo.cd3d5e61.png";